import { defineNuxtPlugin, useHead } from "#imports";
import getCurrentUrl from "#sitis/cms/helpers/getCurrentUrl";
export default defineNuxtPlugin((nuxtApp) => {
  const currentUrl = getCurrentUrl();
  useHead({
    meta: [
      { name: "canonical", content: currentUrl },
      { property: "og:url", content: currentUrl }
    ]
  });
});
